import React, { useEffect } from 'react';
import CoreRadioChips from 'shared/chips/CoreRadioChips';
import CoreSelect from 'shared/CoreSelect';
import useCommonStore from 'store/useCommonStore';
import { StickySectionHeaderRow } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';
import { PlatformCode, PlatformName } from 'type/common';

const chips_arr = ['전체', 'Instagram', 'Youtube', 'Naver Blog', 'TikTok'];

const code_mapper: Record<PlatformName | '전체', PlatformCode | 'ig,yt,nb,tt'> = {
	Instagram: 'ig',
	Youtube: 'yt',
	'Naver Blog': 'nb',
	TikTok: 'tt',
	전체: 'ig,yt,nb,tt',
};

const search_filter_list = [
	{ name: '전체', code: 'total' },
	{ name: '아이디', code: 'username' },
	{ name: '키워드', code: 'etc' },
];

const search_filter_name_list = search_filter_list.map((item) => item.name);

const SearchSelectPlatformRow = () => {
	const { search_platform, setSearchPlatform, search_filter, setSearchFilter } =
		useCommonStore();

	/** 칩스 선택 함수 */
	const setPlatformChips = (platform_name: string) => {
		setSearchPlatform({
			name: platform_name as PlatformName,
			code: code_mapper[platform_name as PlatformName | '전체'],
		});
	};
	/** 선택된 플랫폼이 없을 경우  */
	useEffect(() => {
		if (search_platform.name === null)
			setSearchPlatform({ name: 'Instagram', code: 'ig' });
	}, [search_platform]);

	/** 검색 필터 세팅 */
	const setSearchFilterSelectedOption = (selected: string) => {
		const selected_obj = search_filter_list.find((item) => item.name === selected);

		if (!selected_obj) return;

		setSearchFilter(selected_obj);
	};

	return (
		<StickySectionHeaderRow _padding="8px 16px 16px" sticky_top="73px">
			<style.Grid flex="between" align_items="end">
				<CoreRadioChips
					group_type="carousel"
					style_type="default"
					_width="max-content"
					chips_list={chips_arr}
					selected_chips={search_platform.name ?? ''}
					setSelectedChips={setPlatformChips}
					_disabled={[]}
				/>

				<CoreSelect
					select_type="box"
					_width="120px"
					selected_option={search_filter.name}
					option_list={search_filter_name_list}
					setSelectedOption={setSearchFilterSelectedOption}
				/>
			</style.Grid>
		</StickySectionHeaderRow>
	);
};

export default SearchSelectPlatformRow;
